<template>
    <v-container fluid>
        <v-snackbar
            v-model="showToast"
            color="red lighten-1"
            text
            top
            right
            rounded
            style="margin-top: 75px;"
        >
            {{ toastMsg }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red lighten-1"
                    text
                    v-bind="attrs"
                    @click="showToast = false"
                >
                    <v-icon color="red lighten-1">
                        close
                    </v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-row class="px-6">
            <v-col
                class="mt-4 pb-4 px-0 add-rule-header"
                cols="12"
            >
                <div class="header-content">
                    <div>
                        <v-btn
                            icon
                            style="background: var(--ll-surface-subtle);"
                            @click="backToList"
                        >
                            <v-icon class="material-icons-outlined">
                                chevron_left
                            </v-icon>
                        </v-btn>
                        <span class="ml-3">{{ editMode ? ruleName : 'Add Auto-Assign Rule' }}</span>
                    </div>
                    <DeleteAutoAssignRule
                        v-if="editMode"
                        :rowid="rowid"
                        :rule-name="ruleName"
                        @reload-rules="backToList"
                    />
                </div>
            </v-col>
            <v-col
                class="mt-4 pb-4 pl-0"
                cols="12"
            >
                <div>
                    <v-label>Set the Fields to match on a ticket.</v-label>
                    <v-form
                        ref="form"
                        v-model="formValid"
                    >
                        <v-checkbox
                            v-model="enabled"
                            label="Enabled"
                        />
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-model="ruleName"
                                    dense
                                    :error="errorRuleName"
                                    outlined
                                    label="Rule Name*"
                                    hide-details="true"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-autocomplete
                                    v-model="assignTo"
                                    dense
                                    :error="errorAssignTo"
                                    :items="companyLocators"
                                    item-text="name"
                                    item-value="value"
                                    outlined
                                    label="Assign To*"
                                    hide-details="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-select
                                    v-model="center"
                                    dense
                                    :error="errorCenter"
                                    :items="companyCenters"
                                    item-text="center_tag"
                                    item-value="center_id"
                                    outlined
                                    label="Center*"
                                    hide-details="true"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-slider
                                    v-model="weight"
                                    dense
                                    class="align-center"
                                    max="100"
                                    min="1"
                                    hide-details
                                    color="orange darken-3"
                                    track-color="grey lighten-3"
                                >
                                    <template v-slot:append>
                                        <v-text-field
                                            v-model="weight"
                                            dense
                                            label="Weight"
                                            outlined
                                            hide-details
                                            type="number"
                                            style="width: 70px"
                                            max="100"
                                            min="1"
                                        />
                                    </template>
                                </v-slider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                    style="border-bottom: 1px solid var(--ll-border);"
                                class="p-0 mx-3 mb-3"
                            >
                                <h3 class="py-3">
                                    Criteria
                                </h3>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                                class="pb-0"
                            >
                                <v-select
                                    v-model="memberCode"
                                    :dense="memberCode.length===0"
                                    :items="memberCodes"
                                    item-text="label"
                                    item-value="member_code"
                                    outlined
                                    label="Member Codes"
                                    hint="You can select maximum of 160 characters"
                                    persistent-hint
                                    multiple
                                    small-chips
                                    @input="memberCodeLimiter"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-select
                                    v-model="priority"
                                    dense
                                    :items="companyTicketPriorities"
                                    item-text="label"
                                    item-value="value"
                                    outlined
                                    label="Priority"
                                    hide-details="true"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-select
                                    v-model="type"
                                    dense
                                    :items="companyTicketTypes"
                                    item-text="label"
                                    item-value="value"
                                    outlined
                                    label="Type"
                                    hide-details="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-select
                                    v-if="centerFieldOptions.includes('ticket_category')"
                                    v-model="category"
                                    dense
                                    :items="companyTicketCategories"
                                    item-text="label"
                                    item-value="value"
                                    outlined
                                    label="Category"
                                    hide-details="true"
                                />
                            </v-col>
                            <v-col
                                cols="4"
                                md="2"
                            >
                                <v-select
                                    v-model="mapLayerOper"
                                    dense
                                    :items="layerIntersectionType"
                                    item-text="label"
                                    item-value="value"
                                    outlined
                                    label="Layer Operation"
                                    hide-details="true"
                                />
                            </v-col>
                            <v-col
                                cols="8"
                                md="4"
                            >
                                <v-select
                                    v-model="mapLayer"
                                    dense
                                    :items="companyLayers"
                                    item-text="label"
                                    item-value="value"
                                    outlined
                                    label="Map Layer"
                                    hide-details="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                                class="pb-0"
                            >
                                <v-select
                                    v-model="county"
                                    :dense="county.length===0"
                                    :items="counties"
                                    item-text="label"
                                    item-value="value"
                                    outlined
                                    label="Counties"
                                    hint="You can select maximum of 16 counties"
                                    persistent-hint
                                    multiple
                                    small-chips
                                    @input="countyLimiter"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-model="place"
                                    dense
                                    outlined
                                    label="Place"
                                    hide-details="true"
                                />
                            </v-col>
                            <v-col
                                v-if="centerFieldOptions.includes('subdivision')"
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-model="subdivision"
                                    dense
                                    outlined
                                    label="Subdivision"
                                    hide-details="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-model="street"
                                    dense
                                    outlined
                                    label="Street"
                                    hide-details="true"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-if="centerFieldOptions.includes('company')"
                                    v-model="company"
                                    dense
                                    outlined
                                    label="Company"
                                    hide-details="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="centerFieldOptions.includes('donefor') || centerFieldOptions.includes('doneby')">
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-if="centerFieldOptions.includes('donefor')"
                                    v-model="doneFor"
                                    dense
                                    outlined
                                    label="Done For"
                                    hide-details="true"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-if="centerFieldOptions.includes('doneby')"
                                    v-model="doneby"
                                    dense
                                    outlined
                                    label="Done By"
                                    hide-details="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="centerFieldOptions.includes('caller') || centerFieldOptions.includes('caller_phone')">
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-if="centerFieldOptions.includes('caller')"
                                    v-model="caller"
                                    dense
                                    outlined
                                    label="Caller"
                                    hide-details="true"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-if="centerFieldOptions.includes('caller_phone')"
                                    v-model="callerPhone"
                                    dense
                                    outlined
                                    label="Caller Phone"
                                    hide-details="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="centerFieldOptions.includes('work_type') || centerFieldOptions.includes('location')">
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-if="centerFieldOptions.includes('work_type')"
                                    v-model="workType"
                                    dense
                                    outlined
                                    label="Work Type"
                                    hide-details="true"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-if="centerFieldOptions.includes('location')"
                                    v-model="location"
                                    dense
                                    outlined
                                    label="Location"
                                    hide-details="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="centerFieldOptions.includes('keywords') || centerFieldOptions.includes('grid')">
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-if="centerFieldOptions.includes('keywords')"
                                    v-model="keywords"
                                    dense
                                    outlined
                                    label="Keywords"
                                    hide-details="true"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-if="centerFieldOptions.includes('grid')"
                                    v-model="grid"
                                    dense
                                    outlined
                                    label="Grid"
                                    hide-details="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="centerFieldOptions.includes('instructions')">
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-model="instructions"
                                    dense
                                    outlined
                                    label="Instructions"
                                    hide-details="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-model="remarks"
                                    dense
                                    outlined
                                    label="Comments/Remarks"
                                    hide-details="true"
                                />
                            </v-col>
                        </v-row>
                        <div
                            v-if="centerFieldOptions.includes('meet')"
                            class="py-3 mt-4"
                        >
                            <span>Meet</span>
                            <v-radio-group
                                v-model="meet"
                                row
                                class="mt-0"
                                hide-details="true"
                            >
                                <v-radio
                                    label="Any"
                                    value="*"
                                />
                                <v-radio
                                    label="Yes"
                                    value="Y"
                                />
                                <v-radio
                                    label="No"
                                    value="N"
                                />
                            </v-radio-group>
                        </div>
                        <div
                            v-if="centerFieldOptions.includes('boring')"
                            class="py-3"
                        >
                            <span>Boring</span>
                            <v-radio-group
                                v-model="boring"
                                row
                                class="mt-0"
                                hide-details="true"
                            >
                                <v-radio
                                    label="Any"
                                    value="*"
                                />
                                <v-radio
                                    label="Yes"
                                    value="Y"
                                />
                                <v-radio
                                    label="No"
                                    value="N"
                                />
                            </v-radio-group>
                        </div>
                        <div
                            v-if="centerFieldOptions.includes('explosives')"
                            class="py-3"
                        >
                            <span>Explosives</span>
                            <v-radio-group
                                v-model="explosives"
                                row
                                class="mt-0"
                                hide-details="true"
                            >
                                <v-radio
                                    label="Any"
                                    value="*"
                                />
                                <v-radio
                                    label="Yes"
                                    value="Y"
                                />
                                <v-radio
                                    label="No"
                                    value="N"
                                />
                            </v-radio-group>
                        </div>
                        <div
                            v-if="centerFieldOptions.includes('excav_st_sidewalk')"
                            class="py-3"
                        >
                            <span>Excav St/Sidewalk</span>
                            <v-radio-group
                                v-model="excavStSidewalk"
                                row
                                class="mt-0"
                                hide-details="true"
                            >
                                <v-radio
                                    label="Any"
                                    value="*"
                                />
                                <v-radio
                                    label="Yes"
                                    value="Y"
                                />
                                <v-radio
                                    label="No"
                                    value="N"
                                />
                            </v-radio-group>
                        </div>
                        <div
                            v-if="centerFieldOptions.includes('vacuum')"
                            class="py-3"
                        >
                            <span>Vacuum</span>
                            <v-radio-group
                                v-model="vacuum"
                                row
                                class="mt-0"
                                hide-details="true"
                            >
                                <v-radio
                                    label="Any"
                                    value="*"
                                />
                                <v-radio
                                    label="Yes"
                                    value="Y"
                                />
                                <v-radio
                                    label="No"
                                    value="N"
                                />
                            </v-radio-group>
                        </div>
                        <div
                            v-if="centerFieldOptions.includes('remark')"
                            class="py-3"
                        >
                            <span>Re-Mark</span>
                            <v-radio-group
                                v-model="remark"
                                row
                                class="mt-0"
                                hide-details="true"
                            >
                                <v-radio
                                    label="Any"
                                    value="*"
                                />
                                <v-radio
                                    label="Yes"
                                    value="Y"
                                />
                                <v-radio
                                    label="No"
                                    value="N"
                                />
                            </v-radio-group>
                        </div>
                        <div
                            v-if="centerFieldOptions.includes('delineated')"
                            class="py-3"
                        >
                            <span>Delineated</span>
                            <v-radio-group
                                v-model="delineated"
                                row
                                class="mt-0"
                                hide-details="true"
                            >
                                <v-radio
                                    label="Any"
                                    value="*"
                                />
                                <v-radio
                                    label="Yes"
                                    value="Y"
                                />
                                <v-radio
                                    label="No"
                                    value="N"
                                />
                            </v-radio-group>
                        </div>
                        <div
                            v-if="centerFieldOptions.includes('weekend')"
                            class="py-3"
                        >
                            <span>Weekend</span>
                            <v-radio-group
                                v-model="weekend"
                                row
                                class="mt-0"
                                hide-details="true"
                            >
                                <v-radio
                                    label="Any"
                                    value="*"
                                />
                                <v-radio
                                    label="Yes"
                                    value="Y"
                                />
                                <v-radio
                                    label="No"
                                    value="N"
                                />
                            </v-radio-group>
                        </div>
                        <div
                            v-if="centerFieldOptions.includes('night')"
                            class="py-3"
                        >
                            <span>Night</span>
                            <v-radio-group
                                v-model="night"
                                row
                                class="mt-0"
                                hide-details="true"
                            >
                                <v-radio
                                    label="Any"
                                    value="*"
                                />
                                <v-radio
                                    label="Yes"
                                    value="Y"
                                />
                                <v-radio
                                    label="No"
                                    value="N"
                                />
                            </v-radio-group>
                        </div>
                        <div class="my-4">
                            <v-btn
                                style="text-transform: none !important"
                                outlined
                                light
                                @click="backToList"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                class="ml-3"
                                style="text-transform: none !important"
                                depressed
                                color="primary"
                                @click="save"
                            >
                                {{ editMode ? 'Update' : 'Add' }}
                            </v-btn>
                        </div>
                    </v-form>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import webtmsBackend from '@/services/webtmsBackend';
import DeleteAutoAssignRule from './DeleteAutoAssignRule';
import { getCenterOption } from '@/utils/options';

export default {
    name: 'AddAutoAssignRule',
    components: {
        DeleteAutoAssignRule
    },
    data() {
        return {
            enabled: true,
            formValid: true,
            ruleName: '',
            assignTo: '',
            center: '',
            centerFieldOptions: [],
            weight: 1,
            memberCode: [],
            priority: '*',
            priorityList: [],
            type: '*',
            typeList: [],
            category: '*',
            county: [],
            meet: '*',
            boring: '*',
            explosives: '*',
            mapLayer: '',
            mapLayerOper: '',
            place: '',
            street: '',
            company: '',
            doneFor: '',
            caller: '',
            callerPhone: '',
            workType: '',
            location: '',
            keywords: '',
            grid: '',
            remarks: '',
            excavStSidewalk: '*',
            vacuum: '*',
            remark: '*',
            delineated: '*',  
            instructions: '',
            weekend: '*',
            night: '*',
            subdivision: '',
            doneby: '',
            showToast: false,
            toastMsg: '',
            errorRuleName: false,
            errorCenter: false,
            errorAssignTo: false,
            editMode: false,
            layerIntersectionType: [{ value: '', label: 'Intersects'}, { value: 'NOT', label: 'Does NOT Intersect'}],
            rowid: ''
        };
    },
    computed: {
        companyTicketPriorities() {
            let companyTicketPriorities  = [];
            companyTicketPriorities.push({value: '*',label: 'Any'});
            let ticketPriorites = this.$store.getters.companyTicketPriorities.filter(item => item.center_id === this.center);
            for(let priority of ticketPriorites) {
                companyTicketPriorities.push({value: priority.abbrev, label: `${priority.abbrev} = ${priority.description}`});
            }
            return companyTicketPriorities;
        },
        companyTicketTypes() {
            let companyTicketTypes = [];
            companyTicketTypes.push({value: '*',label: 'Any'});
            let ticketTypes = this.$store.getters.companyTicketTypes.filter(item => item.center_id === this.center);
            for(let ticketType of ticketTypes) {
                companyTicketTypes.push({value: ticketType.abbrev, label: `${ticketType.abbrev} = ${ticketType.description}`});
            }           
            return companyTicketTypes;
        },
        companyTicketCategories() {
            let companyTicketCategories = [];
            companyTicketCategories.push({value: '*',label: 'Any'});
            for(let cat of this.$store.getters.companyTicketCategories) {
                companyTicketCategories.push({value: cat.abbrev, label: `${cat.abbrev} = ${cat.description}`});
            }           
            return companyTicketCategories;
        },
        companyLayers() {
            let layers = [];
            layers.push({value: '{00000000-0000-0000-0000-000000000000}',label: 'No Layer'});
            for(let layer of this.$store.getters.companyLayers) {
                layers.push({value: layer.layer_id, label: layer.name});
            }           
            return layers;
        },
        companyLocators() {
            let companyLocators= [];
            let data = this.$store.getters.companyUsers;
            let locators = data.filter(item => { return item.ingroup.includes('Locator');});
            for(let locator of locators) {
                companyLocators.push({ value: locator.uid, name: `${locator.account} "${locator.name}"` });
            }
            return companyLocators;
        },
        counties() {
            let data = [{label: 'Any', value: '*'}];
            let countiesList = this.$store.getters.counties.filter(item => item[0] === this.center).map((item) => { return { label: `${item[3]}, ${item[2]}`, value: item [1] }; });
            return [...data, ...countiesList];
        },
        companyCenters() {
            return this.$store.getters.companyCenters;
        },
        memberCodes() {
            let data = [{label: 'Any', member_code: '*'}];
            let codes = this.$store.getters.companyMemberCodes.filter(item => item.center_id === this.center);
            codes = codes.sort((a, b) => (a.member_code > b.member_code) ? 1 : -1);
            codes = codes.map(item => {
                item.label = `${item.member_code} = ${item.description}`;
                return item;
            });
            return [...data, ...codes];
        },
        selectedAllMemberCodes() {
            return this.memberCodes.length === this.memberCode.length;
        },
        selectedSomeMemberCodes () {
            return this.memberCode.length > 0 && !this.selectedAllMemberCodes;
        },
        memberCodesIcon () {
            if (this.selectedAllMemberCodes) return 'mdi-close-box';
            if (this.selectedSomeMemberCodes) return 'mdi-minus-box';
            return 'mdi-checkbox-blank-outline';
        },
        selectedAllCounties() {
            return this.counties.length === this.county.length;
        },
        selectedSomeCounties () {
            return this.county.length > 0 && !this.selectedAllCounties;
        },
        countiesIcon () {
            if (this.selectedAllCounties) return 'mdi-close-box';
            if (this.selectedSomeCounties) return 'mdi-minus-box';
            return 'mdi-checkbox-blank-outline';
        },
        user() {
            return this.$store.getters.user;
        }
    },
    watch: {
        center(center) {
            this.setCenterData(center);
        }
    },
    mounted() {
        this.defaultSelection();
        if(this.$route.path.includes('/edit')) {
            this.setSelectedRule();
        }
    },
    methods:  {
        setSelectedRule() {
            let selectedRule = this.$store.getters.selectedAutoAssignRule;
            if(Object.keys(selectedRule).length === 0) {
                this.backToList();
                return;
            }
            this.editMode = true;
            this.rowid = selectedRule.rowid;
            this.enabled = selectedRule.enabled;
            this.ruleName = selectedRule.name;
            this.assignTo = selectedRule.uid;
            this.center = selectedRule.center_id;
            this.weight = selectedRule.weight;
            this.memberCode = selectedRule.member_code.split(',');
            this.priority = selectedRule.ticket_priority;
            this.type = selectedRule.ticket_type;
            this.category = selectedRule.ticket_category;
            this.county = selectedRule.fips.match(/.{1,5}/g);
            this.meet = selectedRule.meet;
            this.boring = selectedRule.boring;
            this.explosives = selectedRule.explosives;
            this.mapLayer = selectedRule.layer_id;
            this.mapLayerOper = selectedRule.layer_oper;
            this.place = selectedRule.place;
            this.street = selectedRule.street;
            this.company = selectedRule.company;
            this.doneFor = selectedRule.donefor;
            this.caller = selectedRule.caller;
            this.callerPhone = selectedRule.caller_phone;
            this.workType = selectedRule.work_type;
            this.location = selectedRule.location;
            this.keywords = selectedRule.keywords;
            this.grid = selectedRule.grid;
            this.remarks = selectedRule.remarks;
            this.excavStSidewalk = selectedRule.excav_st_sidewalk;
            this.vacuum = selectedRule.vacuum;
            this.remark = selectedRule.remark;
            this.delineated = selectedRule.delineated;
            this.instructions = selectedRule.instructions;
            this.weekend = selectedRule.weekend;
            this.night = selectedRule.night;
            this.subdivision = selectedRule.subdivision;
            this.doneby = selectedRule.doneby;
        },
        backToList() {
            this.$store.commit('SET_SELECTED_AUTO_ASSIGN_RULE', {});
            this.$router.go(-1);
        },
        defaultSelection() {
            if (!this.editMode) {
                this.mapLayer = '{00000000-0000-0000-0000-000000000000}';
                if (this.companyCenters.length === 1) this.center = this.companyCenters[0].center_id;
                this.county = ['*'];
            }
            this.setCenterData(this.center);
        },
        setCenterData(val) {
            let findFieldOptions = getCenterOption(val, 'TICKET_RULE_FIELDS');
            if (findFieldOptions) this.centerFieldOptions = findFieldOptions.split(',');
        },
        toggle() {
            this.$nextTick(() => {
                if (this.selectedAllMemberCodes) {
                    this.memberCode = [];
                } else {
                    this.memberCode = this.memberCodes.slice();
                }
            });
        },
        toggleCounty() {
            this.$nextTick(() => {
                if (this.selectedAllCounties) {
                    this.county = [];
                } else {
                    this.county = this.counties.slice();
                }
            });
        },
        memberCodeLimiter(e) {
            if (e.includes('*')) {
                if (e.length === 2) {
                    let tmp = e[1];
                    e.length = 0;
                    e.push(tmp);
                } else {
                    e.length = 0;
                    e.push('*');
                }
            } else if(e.join('').length > 160) {
                e.pop();
                this.showToast = true;
                this.toastMsg = 'You can select maximum of 160 characters';
            }
        },
        countyLimiter(e) {
            if (e.includes('*')) {
                if (e.length === 2) {
                    let tmp = e[1];
                    e.length = 0;
                    e.push(tmp);
                } else {
                    e.length = 0;
                    e.push('*');
                }
            } else if(e.join('').length > 80) {
                e.pop();
                this.showToast = true;
                this.toastMsg = 'You can select maximum of 16 counties';
            }
        },
        async save() {
            this.errorRuleName = false;
            this.errorCenter = false;
            this.errorAssignTo = false;
            if(!this.ruleName) {
                this.errorRuleName = true;
            }
            if(!this.center) {
                this.errorCenter = true;
            }
            if(!this.assignTo) {
                this.errorAssignTo = true;
            }
            if(this.errorRuleName || this.errorCenter || this.errorAssignTo) {
                this.showToast = true;
                this.toastMsg = 'Please enter required fields';
                window.scrollTo(0, 0);
                return;
            }

            let payload = {
                'cid': this.user.cid,
                'name': this.ruleName,
                'uid': this.assignTo,
                'weight': this.weight,
                'center_id': this.center,
                'enabled': this.enabled,
                'member_code': this.memberCode.length > 0 ? this.memberCode.join(',') : '*',
                'ticket_priority': this.priority,
                'ticket_type': this.type,
                'ticket_category': this.category,
                'layer_id': this.mapLayer,
                'layer_oper': this.mapLayerOper,
                'meet': this.meet,
                'excav_st_sidewalk': this.centerFieldOptions.includes('excav_st_sidewalk') ? this.excavStSidewalk : '*',
                'boring': this.boring,
                'explosives': this.explosives,
                'vacuum': this.centerFieldOptions.includes('vacuum') ? this.vacuum : '*',
                'remark': this.centerFieldOptions.includes('remark') ? this.remark : '*',
                'delineated': this.centerFieldOptions.includes('delineated') ? this.delineated : '*',
                'weekend': this.weekend,
                'night': this.night,
                'fips': this.county.length > 0 ? this.county.join('') : '*',
                'place': this.place,
                'subdivision': this.subdivision,
                'street': this.street,
                'grid': this.grid,
                'company': this.company,
                'donefor': this.doneFor,
                'caller': this.caller,
                'caller_phone': this.callerPhone,
                'work_type': this.workType,
                'doneby': this.doneby,
                'location': this.location,
                'remarks': this.remarks,
                'instructions': this.instructions,
                'keywords': this.keywords,
                '__TIMESTAMP__': Date.now()
            };

            if(this.editMode) {
                payload.rowid = this.rowid;
            }
            let response = await webtmsBackend.updateAutoAssignRule(payload);
            if(response && response.result === 'OK') {
                this.$store.commit('SET_SELECTED_AUTO_ASSIGN_RULE', {});
                this.$router.go(-1);
            }
        }
    }
};
</script>

<style>
    .add-rule-header {
        display: flex;
        align-items: center;
        border-bottom: 1px solid var(--ll-border);
        font-weight: 500;
        font-size: 20px;
        color: var(--ll-text-primary);
    }
    .v-slider--horizontal .v-slider__track-container {
        height: 5px;
    }
</style>
